export default __webpack_public_path__ + "static/media/Screenshot (130).bf5c1fc5.png";